module.exports = __webpack_public_path__ + "img/loadding.b398be60.gif";